import { ReactNode } from 'react';

export function explanTemperature() : ReactNode
{
     return <>
        <p>Controls the randomness and creativity of the model's responses. Lower values make output more focused and deterministic, while higher values increase randomness and creativity.</p>
        <ul>
            <li>0.0 - Most deterministic, repeatable responses</li>
            <li>1.0 - Balanced creativity and coherence (recommended for most use cases)</li>
            <li>2.0 - Maximum randomness and creativity</li>
        </ul>
        <p><strong>Note:</strong> For tasks requiring consistency (like data extraction or classification), use lower values (0.0-0.3). For creative tasks (like brainstorming or storytelling), higher values (0.7-1.5) work better.</p>
    </>;
}

